import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component, Injector, Optional } from '@angular/core';
import { Catalog } from '@df/catalog/catalog.interfaces';
import { ImageDirective } from '@df/module-image/image.directive';
import { DfCmsModal } from '@df/ui/modal/df-cms-modal.decorator';
import { NDfModal } from '@df/ui/modal/df-modal.interface';
import { ModalRef } from '@df/ui/modal/modal-ref';
import { UiComponent } from '@df/ui/ui.component';
import { ICmsClientModule } from '@icms/client/icms-client.module';
import { ICmsComponent, ICmsContent, NICmsContentComponent, NICmsContentField } from '@icms/core/content';
import { ModalLayoutRightComponent, NModalLayoutRight } from '../../../../ui/modal/modal-layout-right.component';
export interface IMadeToOrderInfoModalDataContent extends Catalog.IBlockData<IMadeToOrderInfoModalDataContent> {}
export interface IMadeToOrderInfoModalDataContent {
    title: string;
    copy: string;
    firstImage: string;
    secondImage: string;
    thirdImage: string;
}
export const MADE_TO_ORDER_INFO_MODAL_ID = 'made-to-order-info-modal';
@DfCmsModal({
    id: MADE_TO_ORDER_INFO_MODAL_ID,
    name: 'Made to order info modal',
    position: 'right',
    config: sizeName => ({
        ...NModalLayoutRight.ModalConfig,
        width: NModalLayoutRight.getWidth(sizeName),
        modalClass: 'bg-col-w p-a-0'
    }),
    reopenPolicy: NDfModal.ReopenPolicy.first,
    sizeRestriction: ['S', 'M', 'L', 'X']
})
@ICmsComponent<MadeToOrderInfoModalComponent>({
    id: MADE_TO_ORDER_INFO_MODAL_ID,
    block: {
        url: MADE_TO_ORDER_INFO_MODAL_ID
    },
    onDemandOnly: true,
    name: 'Made to order info modal',
    description: 'Made to order info modal',
    fields: [
        <NICmsContentField.IField>{
            key: 'title',
            type: NICmsContentField.EFieldType.text,
            title: 'Title',
            required: true
        },
        <NICmsContentField.IField>{
            key: 'copy',
            type: NICmsContentField.EFieldType.text,
            title: 'Copy',
            required: true
        },
        <NICmsContentField.IField>{
            key: 'firstImage',
            type: NICmsContentField.EFieldType.image,
            title: 'First Image',
            required: true
        },
        <NICmsContentField.IField>{
            key: 'secondImage',
            type: NICmsContentField.EFieldType.image,
            title: 'Second Image',
            required: true
        },
        <NICmsContentField.IField>{
            key: 'thirdImage',
            type: NICmsContentField.EFieldType.image,
            title: 'Third Image',
            required: true
        }
    ]
})
@Component({
    selector: 'made-to-order-info-modal',
    templateUrl: './made-to-order-info-modal.component.html',
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: true,
    imports: [CommonModule, ModalLayoutRightComponent, ImageDirective, ICmsClientModule]
})
export class MadeToOrderInfoModalComponent extends UiComponent implements NICmsContentComponent.IComponent {
    @ICmsContent({
        type: 'blockContent'
    })
    content!: IMadeToOrderInfoModalDataContent;

    constructor(
        override readonly injector: Injector,
        @Optional()
        private modalRef: ModalRef<MadeToOrderInfoModalComponent>
    ) {
        super();
    }
    close() {
        this.modalRef.close();
    }
}
